var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPizzaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#f79d04",
    viewBox: "0 0 91.08 91.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9teg_2",
    "data-name": "R\\xE9teg 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.75,41.83a1.53,1.53,0,0,1-1.06-.44,1.49,1.49,0,0,1-.37-1.49L60.87,1.07a1.5,1.5,0,0,1,1.86-1A42.1,42.1,0,0,1,91,28.35a1.5,1.5,0,0,1-1,1.86L51.18,41.76A1.25,1.25,0,0,1,50.75,41.83ZM63.31,3.39,53,38.1,87.69,27.77A39.13,39.13,0,0,0,63.31,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.75,41.83a1.53,1.53,0,0,1-1.06-.44,1.49,1.49,0,0,1-.37-1.49L59.23,6.58a1.5,1.5,0,0,1,1.86-1A36.3,36.3,0,0,1,85.51,30a1.5,1.5,0,0,1-1,1.86L51.18,41.76A1.25,1.25,0,0,1,50.75,41.83ZM61.67,8.9,53,38.1l29.2-8.69A33.37,33.37,0,0,0,61.67,8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,91.08A42,42,0,1,1,53.86,8.78a1.48,1.48,0,0,1,.89.72,1.51,1.51,0,0,1,.13,1.14L44.22,46.86,80.44,36.2a1.51,1.51,0,0,1,1.14.13,1.48,1.48,0,0,1,.72.89A42,42,0,0,1,42,91.08Zm0-81A39,39,0,1,0,79.82,39.51l-37.39,11a1.51,1.51,0,0,1-1.87-1.87l11-37.39A39.06,39.06,0,0,0,42,10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,85.32a36.25,36.25,0,1,1,10.24-71,1.48,1.48,0,0,1,.89.72,1.46,1.46,0,0,1,.12,1.14l-9,30.71,30.71-9a1.46,1.46,0,0,1,1.14.12,1.48,1.48,0,0,1,.72.89A36.24,36.24,0,0,1,42,85.32Zm0-69.5A33.26,33.26,0,1,0,74.3,41.14L42.43,50.52a1.51,1.51,0,0,1-1.87-1.87l9.38-31.87A33,33,0,0,0,42,15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.67,70.49a8,8,0,1,1,5.62-2.33A7.91,7.91,0,0,1,29.67,70.49Zm0-12.89A4.94,4.94,0,1,0,33.17,59,5,5,0,0,0,29.67,57.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15,30.4a6.46,6.46,0,0,1-4.57-11,6.46,6.46,0,1,1,9.14,9.14A6.38,6.38,0,0,1,67.15,30.4Zm0-9.94a3.46,3.46,0,0,0-2.45,5.92,3.55,3.55,0,0,0,4.9,0,3.47,3.47,0,0,0-2.45-5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.49,71.44A9.15,9.15,0,1,1,64,68.76,9.12,9.12,0,0,1,57.49,71.44Zm0-15.3a6.15,6.15,0,1,0,4.35,1.8A6.1,6.1,0,0,0,57.49,56.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.58,45.94a9.72,9.72,0,1,1,6.88-2.84A9.69,9.69,0,0,1,27.58,45.94Zm0-16.44a6.73,6.73,0,1,0,4.76,2A6.7,6.7,0,0,0,27.58,29.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.56,30.4a1.52,1.52,0,0,1-1.37-.89L36.5,25.69a1.5,1.5,0,1,1,2.74-1.22l1.69,3.82a1.5,1.5,0,0,1-.76,2A1.63,1.63,0,0,1,39.56,30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,48a1.47,1.47,0,0,1-.93-.33l-2.76-2.19a1.5,1.5,0,1,1,1.87-2.34L18,45.32a1.51,1.51,0,0,1,.25,2.11A1.53,1.53,0,0,1,17,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,61.88a1.5,1.5,0,0,1-1.5-1.5V56.31a1.5,1.5,0,1,1,3,0v4.07A1.5,1.5,0,0,1,43,61.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,77.82A1.49,1.49,0,0,1,41,77.38L38.58,75a1.5,1.5,0,0,1,2.12-2.12l2.4,2.4a1.51,1.51,0,0,1,0,2.12A1.53,1.53,0,0,1,42,77.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.34,53.93a1.31,1.31,0,0,1-.39,0A1.5,1.5,0,0,1,65.89,52l1-3.78a1.5,1.5,0,1,1,2.89.78l-1,3.78A1.5,1.5,0,0,1,67.34,53.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52,58.87a2,2,0,1,1,0-2.83A2,2,0,0,1,17.52,58.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.67,50a1.63,1.63,0,1,1-2.3-2.3,1.62,1.62,0,0,1,2.3,0A1.64,1.64,0,0,1,36.67,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.77,67.22a1.15,1.15,0,1,1,0-1.62A1.14,1.14,0,0,1,18.77,67.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.62,
    cy: 67.42,
    r: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,23.17a1.62,1.62,0,1,1,0-2.29A1.62,1.62,0,0,1,31.3,23.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.68,
    cy: 74.49,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.85,77a1.39,1.39,0,0,1-2,0,1.41,1.41,0,0,1,0-2,1.4,1.4,0,1,1,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.71,
    cy: 31.37,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.52,15.77a1.5,1.5,0,0,1-.37-2.95l1.91-.5a1.5,1.5,0,0,1,.75,2.91l-1.91.49A1.58,1.58,0,0,1,63.52,15.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,22.75a1.7,1.7,0,1,1-2.4-2.4,1.7,1.7,0,0,1,2.4,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,53.93a1.45,1.45,0,0,1-1.06-.44,1.49,1.49,0,0,1,0-2.12l2.68-2.68a1.5,1.5,0,1,1,2.12,2.12L25,53.49A1.48,1.48,0,0,1,24,53.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,41.07a1.5,1.5,0,0,1-.6-2.87l4.14-1.81a1.5,1.5,0,0,1,1.2,2.75L41.79,41A1.57,1.57,0,0,1,41.19,41.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaIcon);
export default __webpack_public_path__ + "static/media/pizza-icon.518e92c13f8abb5d9c59c68682abbed9.svg";
export { ForwardRef as ReactComponent };